export enum CCOFranceBLMCurtailmentScenario {
	Fully = "FULLY_CURTAILABLE",
	CallProgram = "PA_ONLY",
}

export enum CCOFranceECOCurtailmentType {
	NoEconomicalCurtailment = "NO_ECONOMICAL_CURTAILMENT",
	DAOnly = "DA_ONLY",
	FullFlex = "FULL_FLEX",
	M0DA = "M0_DA",
	M0FullFlex = "M0_FULL_FLEX",
	BaseprodDA = "BASEPROD_DA",
	BaseprodFullFlex = "BASEPROD_FULL_FLEX",
}

export enum CCOFrancePricingMethod {
	InvoicePrice = "INVOICE_PRICE",
	Index = "INDEXED_PRICE",
	ContractPrice = "CONTRACT_PRICE",
}

export enum CCOFrancePricingIndex {
	EpexSpotFRPowerQHDA = "Epex Spot FR Power QH DA",
	EpexSpotFRPowerHDA = "Epex Spot FR Power H DA",
}
export const FULL_FLEX_EC_TYPES = [
	CCOFranceECOCurtailmentType.BaseprodFullFlex,
	CCOFranceECOCurtailmentType.M0FullFlex,
	CCOFranceECOCurtailmentType.FullFlex,
];
